module.exports = __webpack_public_path__ + "img/erudio_maos_fundo_vermelho.458234aa.svg";